<template>
  <div
    id="app"
    lang="ar"
    class="h-100"
    :class="[skinClasses]"
  >
    <component :is="layout">
      <router-view />
    </component>
    <button id="open-alert" v-b-modal.alert-modal class="dnone"></button>
    <b-modal id="alert-modal" hide-footer size="sm">
      <div id="alert-msg" class="text-dark"></div>
    </b-modal>
  </div>
</template>

<script>

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,

  },
  data(){
    return {
      langx: localStorage.getItem('lang')
    }
  },
  created(){
    if(localStorage.getItem('user')){
      var g = this;
      if(JSON.parse(localStorage.getItem('user'))?.jwt){
        function ggcc(){
          $.post(api + '/user'+'/auth/check', {
            jwt: JSON.parse(localStorage.getItem('user'))?.jwt
          }).then(function(r){
            if(r.status != 100){
              localStorage.removeItem('user')
              window.location = '/logout'
            }else{
              if(JSON.stringify(r.response) != localStorage.getItem("user")){
                setTimeout(() => {
                  location.reload()
                }, 100);
              }
              localStorage.setItem('user', JSON.stringify(r.response))
            }
            var t = r.response;
            setInterval(() => {
              if(t){
                if(t.phone){
                  if(!t.activated && t.tahdir_user_id == ""){
                    if(!window.location.href.includes("activate")){
                      window.location = '/activate?id=' + t._id
                    }
                  }
                }
              }
              if(t.tahdir_user_id == "" || t.school_not_subscribed){
                if(new Date().getTime() >= new Date(t.exdate).getTime()){
                  if(!window.location.href.includes("subscribe")){
                    window.location = '/subscribe?expired' + (t.school_not_subscribed ? 'school' : '')
                  }
                }
              }
            }, 1000);
          }).fail(function(r){
            console.log(r)
          })
        }
        ggcc()
      }else{
        localStorage.removeItem('user')
        window.location = '/'
      }
    }
  },
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>
